import PubSub from "underpub-js";
import SimpleLightbox from "simplelightbox/dist/simple-lightbox.jquery.js";

var MediaPrimary = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-MediaPrimary',
	};

	$.extend(true, this.options, options);

};

MediaPrimary.prototype.init = function() {

	var self = this;

	// Initialize slide tracking
	self.currentSlideIndex = 0;

	let lightbox = this.options.$el.find(".el-Carousel__slide img").simpleLightbox({
		sourceAttr: "src",
		scrollZoom: false
	});

	self.$arrowWrapper = this.options.$el.find(".el-Carousel__arrows");
	self.$arrowWrapper.on("click", function(e){
	
		// Don't open lightbox if clicking on arrow buttons or their children
		if ($(e.target).closest(".el-Carousel__arrow--prev").length || $(e.target).closest(".el-Carousel__arrow--next").length) {
			e.preventDefault();
			e.stopImmediatePropagation();
			return false;
		}

		let slideIndex = self.currentSlideIndex;
		lightbox.openPosition(slideIndex);	
		
	});

	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	self.$arrowPrev.on('click', function () {
		PubSub.publish("Carousel:previousSlideIfChild", {
			$parent: self.options.$el
		})
	});

	self.$arrowNext.on('click', function () {
		PubSub.publish("Carousel:nextSlideIfChild", {
			$parent: self.options.$el
		});
	});

	// Subscribe to carousel slide changes to track current slide index
	PubSub.subscribe('Carousel:slideChanged', function(data) {
		if (data.$parent) {
			self.currentSlideIndex = data.currentIndex;
			self.totalSlides = data.totalSlides;
		}
	});

};

export default MediaPrimary;
